import { useTypedQuery } from "hooks";
import { UsersDashboardQueryKeys } from "modules/UsersDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

export const useDevicesQuery = (userId: number | null) =>
  useTypedQuery({
    queryKey: UsersDashboardQueryKeys.devices,
    queryFn: async ({ endpoint, baseUrl }) => (await ApiInstance.post(endpoint, { user_id: userId ?? 0 }, baseUrl)).data.devices,
    enabled: !!userId,
    initialData: []
  });
